import { render, staticRenderFns } from "./DocumentObjectPriceEdit.vue?vue&type=template&id=bb2f343a&"
import script from "./DocumentObjectPriceEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentObjectPriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports